const contextPath = 'common/context';

export class AppContext {
    constructor($window) {
        this.$window = $window;
        this.initialize();
    }

    initialize() {
        this.setMicroservices();
        this.setLicenses();
    }

    setMicroservices() {
        this.microservicesNames = this.getMicroservicesNames();
    }

    setLicenses() {
        this.xrayLicensesList = this.getXrayLicenses();
        this.platformLicensesList = this.getPlatformLicenses();
    }

    getMicroservicesNames() {
        return this.$window.store.getters[`${contextPath}/GET_MICROSERVICES_CONSTANTS`];
    }

    getMicroservices() {
        return this.$window.store.getters[`${contextPath}/GET_MICROSERVICES`];
    }

    isMicroserviceAvailable(microservice) {
        return this.$window.store.getters[`${contextPath}/IS_MICROSERVICE_AVAILABLE`](microservice);
    }

    getXrayLicenses() {
        return this.$window.store.getters[`${contextPath}/GET_XRAY_REQUIRED_LICENSE_TYPES`];
    }

    getPlatformLicenses() {
        return this.$window.store.getters[`${contextPath}/GET_PLATFORM_LICENSE_TYPES`];
    }

    getInstalledLicense() {
        return this.$window.store.getters[`${contextPath}/GET_LICENSE_TYPE`];
    }

    isSaas() {
        return this.$window.store.getters[`${contextPath}/GET_IS_CLOUD`];
    }

    isEntPlus() {
        return this.$window.store.getters[`${contextPath}/IS_ENT_PLUS`];
    }

    hasXrayLicense() {
        const installedLicense = this.getInstalledLicense();
        return this.xrayLicensesList.indexOf(installedLicense && installedLicense.name) >= 0;
    }

    hasPlatformLicense() {
        const installedLicense = this.getInstalledLicense();
        return this.platformLicensesList.indexOf(installedLicense && installedLicense.name) >= 0;
    }

    hasXray() {
        const microservices = this.getMicroservices();
        return !!(microservices && microservices[this.microservicesNames.XRAY]);
    }

    hasDistribution() {
        const microservices = this.getMicroservices();
        return !!(microservices && microservices[this.microservicesNames.DISTRIBUTION]);
    }

    isXrayUp() {
        return this.hasXray() && this.hasXrayLicense() && this.isMicroserviceAvailable(this.microservicesNames.XRAY);
    }

    hasPipelines() {
        const microservices = this.getMicroservices();
        return (this.isSaas() || this.isEntPlus()) && !!(microservices && microservices[this.microservicesNames.PIPELINES]);
    }

    isPipelinesUp() {
        return this.hasPipelines() && this.isMicroserviceAvailable(this.microservicesNames.PIPELINES);
    }

    isDistributionUp() {
        return this.hasDistribution() && this.hasPlatformLicense() && this.isMicroserviceAvailable(this.microservicesNames.DISTRIBUTION);
    }

    getDistributionPairingStatus() {
        const {isPaired, message} = window.store.getters[`${contextPath}/GET_PAIRING_STATUS`];
        return {isPaired, message};
    }

    setPairingStatus(status) {
        window.store.dispatch(`${contextPath}/SET_PAIRING_STATUS`, {isPaired: status});
    }
}



// WEBPACK FOOTER //
// ./services/context_service.js